/** Action type that submits one form's lead. */
export const LEAD_SUBMIT_ACTION_TYPE = 'lead.submit';

/**
 * Param the runtime sets on `lead.submit` to name the form the click happened
 * in. Authored values are discarded; outside a form the param is absent.
 */
export const LEAD_SUBMIT_FORM_PARAM = '__formName';

/** Prefix of the `lead.submit` status and error keys in `formState`. They never enter `flowState`. */
export const LEAD_SUBMIT_STATE_PREFIX = 'leadSubmit__';

export function isLeadSubmitStateKey(key: string): boolean {
  return key.startsWith(LEAD_SUBMIT_STATE_PREFIX);
}

type LeadSubmitStatePart = 'status' | 'busy' | 'error';

/** `leadSubmit__<formName>__<part>`, or `leadSubmit__<part>` outside a form. */
export function leadSubmitStateKey(
  part: LeadSubmitStatePart,
  formName?: string,
): string {
  return formName
    ? `${LEAD_SUBMIT_STATE_PREFIX}${formName}__${part}`
    : `${LEAD_SUBMIT_STATE_PREFIX}${part}`;
}

/** `leadSubmit__<formName>__error__<formKey>`, or `leadSubmit__error__<formKey>` outside a form. */
export function leadSubmitFieldErrorKey(
  formKey: string,
  formName?: string,
): string {
  return `${leadSubmitStateKey('error', formName)}__${formKey}`;
}
